import { render, staticRenderFns } from "./DetailsBankSlip.vue?vue&type=template&id=6fac7fb6&scoped=true"
import script from "./DetailsBankSlip.vue?vue&type=script&lang=js"
export * from "./DetailsBankSlip.vue?vue&type=script&lang=js"
import style0 from "./DetailsBankSlip.vue?vue&type=style&index=0&id=6fac7fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac7fb6",
  null
  
)

export default component.exports